// A section on why now is the perfect time to improve one's cybersecurity
const Now = () => {
	return (
		<section id="now">
			<header>
				<h3>
					Why is NOW the perfect time to do something about cybersecurity?
				</h3>
			</header>
			<main>
				<p>
					Cybercrime today costs the world up to $1 trillion annually, more than
					1% of global GDP, an increase of 50% over 2020. With the increase of
					digitalization and home office due to the pandemic in the last 2
					years, cyberattacks have become even more frequent and efficient than
					they already were. With the shift to home office and remote working,
					employees are much more exposed to attacks from professional hackers
					and are usually very uninformed about cyber security. The technology
					is also getting better and better and the possibilities hackers have
					at their disposal are becoming more and more efficient, which means
					that the attacks are also becoming more and more serious.
				</p>
			</main>
		</section>
	);
};
export { Now };
